<template>
  <div>
    <b-loading
      :is-full-page="false"
      v-model="isloading"
    >
    <font-awesome-icon
        icon="fa-solid fa-sync" spin
        size="2x">
      </font-awesome-icon>
      <div style="padding-left:10px;"> Loading Data </div>
      </b-loading>
    <div
      class="card-test"
      :v-if="!isloading"
    >
      <b-field label="Select Date">
        <div class="columns is-mobile is-centered is-vcentered">
          <b-datepicker
            class="column is-one-quarter"
            v-model="selectedDate"
            icon="calendar-today"
            trap-focus
            :max-date="maxDate"
            @input="goSeletedDay => {
                  unloadedData()
                  initStore()
                  updateTimeStamp = dateFormatter
                }"
          >
          </b-datepicker>
          <b-button
            class="column is-1 is-primary"
            @click="goToday =>{
        selectedDate = new Date()
        initStore()
        }"
          >Go Today</b-button>
        </div>
      </b-field>
      <!-- <div class="column">
          <div class="title-text-style"> - DriverPerformance</div>
        </div> -->
      <b-field label="Select Branch">
        <b-select
          placeholder="select Branch"
          v-model="selectedBranch"
        >
          <option
            v-for="(name,i) in getAvaiableBranch"
            :key="i"
          >
            {{ name }}
          </option>
        </b-select>
      </b-field>
      <CardContent
        title='Delivery Status'
        :datetime='updateTimeStamp'
      >
        <div class="columns is-vcentered is-multiline is-centered">
          <div class="column is-half">
            <Charttest
              title="t1"
              :option="setPieChart"
              height="500px"
            />
          </div>
          <div class="column is-half">
            <p>Most On-time Driver</p>

            <!-- <b-field label="">
              <b-select
                placeholder="Select Data Range"
                v-model="selectedDataRange"
                @input="onupdateTest()"
              >
                <option
                  v-for="(type,i) in dataRange"
                  :key="i"
                >
                  {{ type }}
                </option>
              </b-select>
            </b-field> -->
            <b-table
              :sticky-header="true"
              :centered="true"
              :data="tableLate"
              :columns="tableHeader"
              :hoverable="true"
              :striped="true"
              :height="500"
            >
            </b-table>
            <b-table><template #footer>
                <th class="has-text-left">Success Order</th>
                <th>{{sumSuccessOrder}}</th>
                <th>Order(s)</th>
              </template></b-table>
          </div>
        </div>
      </CardContent>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { optionPie } from '@/setting/ChartOptionPie'
// import branchs from '@/setting/branchs.js'

export default {
  components: {
    CardContent: () => import('@/components/CardContent.vue'),
    Charttest: () => import('@/components/Charttest.vue')
  },
  data () {
    return {
      maxDate: new Date(),
      selectedDate: new Date(),
      selectedBranch: 'Sukhumvit 33',
      // branchs: branchs,
      updateTimeStamp: dayjs().format('YYYY-MM-DD HH:00:00'),
      dataRange: ['AllTime', 'Daily'],
      selectedDataRange: 'Daily',
      isloading: false,
      tableHeader: [
        {
          field: 'driverName',
          label: 'Driver Name',
          centered: true
        },
        {
          field: 'delivered',
          label: 'Delivered',
          centered: true
        },
        {
          field: 'onTimeRatioDriver',
          label: '% On-Time Delivered',
          centered: true
        }
      ]
    }
  },
  mounted () {
    this.initStore()
    this.onUpdateEveryHour()
    this.intervalidUpdate = setInterval(() => {
      this.onUpdateEveryHour()
    }, 600000)
  },
  computed: {
    sumSuccessOrder () {
      const { successOrderBranch } = this.getBranchData
      return successOrderBranch.late + successOrderBranch.notLate
    },
    dateFormatter () {
      // console.log(
      //   'dateFormatter',
      //   this.selectedDate,
      //   'return',
      //   dayjs(this.selectedDate).format('YYYY-MM-DD')
      // )
      return dayjs(this.selectedDate).format('YYYY-MM-DD')
    },
    dateTimeFormatter () {
      let dateTime
      if (this.dateFormatter === dayjs().format('YYYY-MM-DD')) {
        dateTime = dayjs().subtract(8, 'hour').format('YYYY-MM-DDTHH:59:59[Z]')
      } else {
        dateTime = dayjs(this.selectedDate).format('YYYY-MM-DDT16:59:59[Z]')
      }
      // console.log('dateTimeFormatter', this.selectedDate, 'return', dateTime)
      return dateTime
    },
    getListDriverLateNotLate () {
      const _temp = this.$store.getters['driverPerform/listOfDriver']
      console.log('lateDriver', _temp)
      return _temp
    },
    getAvaiableBranch () {
      try {
        const { availableBranch } = this.getBranchData
        return availableBranch
      } catch (error) {
        console.log(error)
        return false
      }
    },
    getBranchData () {
      try {
        console.log('branchs', this.branchs)
        return this.getSeperateBranch(this.selectedBranch)
      } catch (error) {
        console.log(error)
        return false
      }
    },
    setPieChart () {
      const _thisChart = { ...optionPie }
      const { successOrderBranch } = this.getBranchData
      const chart = this.setLateOnTimeSeries(successOrderBranch, _thisChart)
      // console.log('chartttttt', chart)
      return chart
    },
    tableLate () {
      const { listTable, successOrderBranch } = this.getBranchData
      const listDriver = this.setTableLate(listTable, successOrderBranch)
      return listDriver
    }
  },
  methods: {
    unloadedData () {
      console.log('TestTimeout Start')
      console.log('this.isloading', this.isloading)
      setTimeout((unload) => {
        if (this.isloading || !this.getListDriverLateNotLate) {
          console.log('this.isloading', this.isloading)
          this.selectedDate = new Date()
          this.initStore()
          console.log('TestTimeout End')
          this.$buefy.notification.open({
            message: 'No Data On Your Seleted Date!\n return To Today',
            type: 'is-danger'
          })
        }
        console.log('TestTimeout Tricker')
      }, 5000)
    },
    async onupdateTest () {
      await this.$store.dispatch(
        'driverPerform/getListOfDriver',
        this.selectedDataRange
      )
      // console.log('testttttTrigger', this.selectedDataRange)
    },
    getSeperateBranch (_branchName) {
      let _data = ''
      if (this.getListDriverLateNotLate.latesDriverDaily) {
        _data = this.getListDriverLateNotLate.latesDriverDaily.items
        // console.log('Day', _data)
      } else {
        _data = this.getListDriverLateNotLate.latesDriverAllTime.items
        // console.log('All', _data)
      }
      let late = 0
      let notLate = 0
      const findBranch = []
      const listTable = []
      console.log('_branchName', _branchName)
      _data.forEach((arr) => {
        findBranch.push(arr.origin)
        if (arr.origin === _branchName) {
          listTable.push({
            driverName: arr.driverName,
            late: arr.late,
            notLate: arr.notLate
          })
          late += arr.late
          notLate += arr.notLate
        }
      })
      const successOrderBranch = { late, notLate }
      const availableBranch = [...new Set(findBranch)]
      console.log('listTable', listTable)
      console.log('branchs', availableBranch)
      return { listTable, successOrderBranch, availableBranch }
    },
    setTableLate (_data, _successOrder) {
      const _new = []
      // let index = 1
      // const _allOrder = _successOrder.late + _successOrder.notLate
      for (const i of _data) {
        const _delivered = i.late + i.notLate
        // const _onTimeRatioAll = (i.notLate / _allOrder) * 100
        const _onTimeRatioDriver = (i.notLate / _delivered) * 100
        _new.push({
          // no: index,
          driverName: i.driverName,
          delivered: _delivered,
          // branch: i.origin,
          onTimeRatioDriver: _onTimeRatioDriver.toFixed(2)
        })
        // index++
      }
      _new.sort((a, b) => b.onTimeRatioDriver - a.onTimeRatioDriver)
      // console.log('_allOrder', _allOrder)
      console.log('doTable', _new)
      return _new
    },
    setLateOnTimeSeries (_series, _chart) {
      _chart.series = [
        {
          type: 'pie',
          radius: ['30%', '60%'],
          label: {
            formatter: '{b|{b}} : {per|{d}%} \n {c|{c} orders} ',
            rich: {
              c: {
                color: '#86D4B5',
                lineHeight: 22,
                align: 'center',
                fontSize: 25
              },
              d: {
                borderColor: '#8C8D8E',
                width: '100%',
                borderWidth: 1,
                height: 0
              },
              b: {
                color: '#4C5058',
                fontSize: 18,
                fontWeight: 'bold',
                lineHeight: 33
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4
              }
            }
          },
          data: [
            { value: _series.notLate, name: 'On-time' },
            { value: _series.late, name: 'Late' }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
      return _chart
    },
    async initStore () {
      this.isloading = true
      // console.log('initStore', this.isloading)
      this.updateTimeStamp = dayjs().format('YYYY-MM-DD HH:00:00')
      await this.$store.dispatch('driverPerform/getListOfDriver', {
        dataRange: this.selectedDataRange,
        _dateTime: this.dateTimeFormatter
      })
      this.isloading = false
      // console.log('initStore', this.isloading)
    },
    async onUpdateEveryHour () {
      const timmerCheck = dayjs().get('minute')
      console.log(timmerCheck)
      if (timmerCheck <= 10) {
        await this.$store.dispatch('driverPerform/getListOfDriver', {
          dataRange: this.selectedDataRange,
          _dateTime: this.dateTimeFormatter
        })
        this.updateTimeStamp = dayjs().format('YYYY-MM-DD HH:00:00')
      }
    }
  },
  beforedestroy () {
    clearInterval(this.intervalidUpdate)
  }
}
</script>

<style scoped>
.card-test {
  margin-bottom: 50px;
  padding: 25px;
}
.title-text-style {
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
  margin-bottom: 10px;
  font-size: 35px;
  color: #1e4b84;
}
</style>
